import React from 'react'
import { connect } from 'react-redux'
import { DynamicModuleLoader } from 'redux-dynamic-modules'
import { Route } from 'react-router-dom'
import Loadable from 'react-loadable'
import modules, { init } from './modules'
import Loading from 'components/Loading'

export default function(route) {
  const Agreement = Loadable({
    loader: () => import('./Agreement'),
    render(loaded, props) {
      const Component = connect((state) => ({
        routesAgreementState: state.routesAgreementState,
        siteConfig: state.siteConfig
      }), {
        init
      })(loaded.default)
      return <Component {...props} />
    },
    loading: Loading
  })

  return (
    <Route
      path='/agreement'
      render={routeProps => (
        <DynamicModuleLoader modules={[modules(routeProps.history)]}>
          <Agreement {...routeProps} />
        </DynamicModuleLoader>
      )}
    />
  )
}
